import axios from "axios";

export const domain = "https://admin.bolpatranepal.com/api/v1";

axios.defaults.withCredentials = true;
const instance = axios.create({
  baseURL: domain,
});

instance.interceptors.request.use(
  (req: any) => {
    return req;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (res: any) => {
    return res;
  },
  (error: any) => {
    return Promise.reject(error);
  }
);

export default instance;
